// src/components/VisionMission.jsx
import React from 'react';

const visionItems = [
  { icon: '💪', title: 'Strong Mind',      desc: "Building mental strength to overcome life's challenges." },
  { icon: '🔄', title: 'Self Discipline',  desc: "Encouraging self-control and positive habits." },
  { icon: '✨', title: 'Change',           desc: "True inspiring transformation that begins from the heart." },
  { icon: '🎯', title: 'Challenge',        desc: "Helping individuals overcome limitations and discover possibilities." },
  { icon: '🤝', title: 'Cohesion',         desc: "Promoting unity beyond language, religion, nationality, and ethnicity." },
];

const VisionMission = () => {
  return (
    <section className="viha-section" style={styles.section}>
      {/* Wave top */}
      <div className="wave-divider" style={{ marginBottom: -2 }}>
        <svg viewBox="0 0 1440 60" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{ display: 'block' }}>
          <path d="M0,30 C480,60 960,0 1440,30 L1440,0 L0,0 Z" fill="#ffffff" />
        </svg>
      </div>

      <div style={styles.container}>
        <div style={styles.header}>
          <span className="section-badge">Our Purpose</span>
          <h2 style={styles.sectionTitle}>Vision &amp; Mission</h2>
        </div>

        <div style={styles.grid}>
          {/* Vision Card */}
          <div className="viha-card" style={{ ...styles.card, ...styles.visionCard }} data-aos="zoom-in" data-aos-delay="100">
            <div style={{ ...styles.topBorder, backgroundColor: '#5A9E4B' }} />
            <div style={styles.cardIcon}>🌿</div>
            <h3 style={styles.cardTitle}>Our Vision</h3>
            <ul style={styles.list}>
              {visionItems.map((item) => (
                <li key={item.title} style={styles.listItem}>
                  <span style={styles.listIcon}>{item.icon}</span>
                  <div>
                    <strong style={styles.itemTitle}>{item.title}</strong>
                    <p style={styles.itemDesc}>{item.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Mission Card */}
          <div className="viha-card" style={{ ...styles.card, ...styles.missionCard }} data-aos="zoom-in" data-aos-delay="300">
            <div style={{ ...styles.topBorder, backgroundColor: '#1B3F6E' }} />
            <div style={styles.cardIcon}>🎯</div>
            <h3 style={styles.cardTitle}>Our Mission</h3>
            <p style={styles.missionText}>
              {/* To promote mental wellness and emotional strength by providing compassionate,
              professional, and confidential psychological care that empowers individuals
              to overcome challenges, improve relationships, and lead healthy, fulfilling lives. */}
              Our mission is to deliver ethical and evidence-based psychological services for children,
              adolescents, adults, couples, and families through counceling, guidance and mental health
              support while creating awareness about emotional well-being in society.
            </p>
            <div style={styles.missionQuote}>
              {/* <p style={styles.missionQuoteText}>"Healing Minds, Empowering Lives."</p> */}
                 <p style={styles.missionQuoteText}>"Change Your Mind, Change Your Life- <br></br>  A Healthy Mind Leads To A Happy Life."</p>
            </div>
            <div style={styles.pillsWrap}>
              {['Compassionate Care', 'Confidential', 'Professional', 'Inclusive'].map((p) => (
                <span key={p} style={styles.missionPill}>{p}</span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Wave bottom */}
      <div className="wave-divider" style={{ marginTop: 40 }}>
        <svg viewBox="0 0 1440 60" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{ display: 'block' }}>
          <path d="M0,30 C480,0 960,60 1440,30 L1440,60 L0,60 Z" fill="#ffffff" />
        </svg>
      </div>
    </section>
  );
};

const styles = {
  section: {
    backgroundColor: '#E8F5E2',
    paddingTop: 0,
    paddingBottom: 0,
  },
  container: {
    maxWidth: 1100,
    margin: '0 auto',
    padding: '60px 24px',
  },
  header: {
    textAlign: 'center',
    marginBottom: 48,
  },
  sectionTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 'clamp(26px, 3.5vw, 36px)',
    color: '#1B3F6E',
    marginTop: 8,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: 32,
  },
  card: {
    padding: '36px 32px',
    position: 'relative',
    overflow: 'hidden',
    borderRadius: 20,
  },
  visionCard: {},
  missionCard: {},
  topBorder: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 5,
    borderRadius: '20px 20px 0 0',
  },
  cardIcon: {
    fontSize: 40,
    marginBottom: 16,
  },
  cardTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 24,
    fontWeight: 700,
    color: '#1B3F6E',
    marginBottom: 24,
  },
  list: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  listItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 14,
  },
  listIcon: {
    fontSize: 22,
    lineHeight: 1.4,
    flexShrink: 0,
  },
  itemTitle: {
    fontFamily: "'Lato', sans-serif",
    fontSize: 14,
    fontWeight: 700,
    color: '#1B3F6E',
    display: 'block',
    marginBottom: 2,
  },
  itemDesc: {
    fontSize: 14,
    color: '#6C757D',
    lineHeight: 1.5,
    margin: 0,
  },
  missionText: {
    fontSize: 15,
    color: '#4a5568',
    lineHeight: 1.85,
    marginBottom: 28,
  },
  missionQuote: {
    background: '#1B3F6E',
    borderRadius: 12,
    padding: '20px 24px',
    marginBottom: 24,
  },
  missionQuoteText: {
    fontFamily: "'Playfair Display', serif",
    fontStyle: 'italic',
    fontSize: 18,
    fontWeight: 600,
    color: '#ffffff',
    margin: 0,
    textAlign: 'center',
  },
  pillsWrap: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
  },
  missionPill: {
    background: '#D6E8F7',
    color: '#1B3F6E',
    borderRadius: 50,
    padding: '5px 14px',
    fontSize: 12,
    fontWeight: 700,
    fontFamily: "'Lato', sans-serif",
  },
};

export default VisionMission;
